module.exports = __webpack_public_path__ + "static/img/16.91ddece.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/16.jpg
// module id = 287
// module chunks = 0